enum IconModes {
    ERROR = 'error',
    INFO = 'info',
    SHADOWED = 'shadowed',
}

export { IconModes };
